import { SVGProps } from "react";

const STIHackernews = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Hacker News" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#f60" /><path fill="#fff" d="M124 91h51l81 162 81-164h51L276 293v136h-40V293z" /></svg>;

export { STIHackernews };